import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { getlanguagelist } from "../../helpers/changelanguage";


class FooterLink extends Component {

   componentDidMount(){
   
   }

    backButton() {
      window.history.back();
    }
    render() {
      let  languagelist = getlanguagelist();
      return (
       
           
           
      

        <ul>
        <li><a href="https://www.facebook.com/baal.dahab.92"><img src="https://api.baaldahab.com/backend_assets/website/img/follow_icon1.png" /></a></li>
        <li><a href="https://twitter.com/BaalDahab114"><img src="https://api.baaldahab.com/backend_assets/website/img/follow_icon2.png" /></a></li>
        <li><a href="https://www.instagram.com/baaldahab114/"><img src="https://api.baaldahab.com/backend_assets/website/img/follow_icon3.png" /></a></li>
        <li><a href="https://www.youtube.com/channel/UCFlbSLi_NJTYsKygr3IkNqg?view_as=subscriber"><img src="https://api.baaldahab.com/backend_assets/website/img/follow_icon4.png" /></a></li>
        <li><a href="https://www.pinterest.co.uk/baaldahab/"><img src="https://api.baaldahab.com/backend_assets/website/img/follow_icon5.png" /></a></li>
        <li><a href="https://www.linkedin.com/in/baal-dahab-6b7b1a179/"><img src="https://api.baaldahab.com/backend_assets/website/img/follow_icon6.png" /></a></li>
        <li><a href="https://plus.google.com/108469103898795855923"><img src="https://api.baaldahab.com/backend_assets/website/img/follow_icon7.png" /></a></li>
        </ul>
       
      
      );
    }
  }
export default FooterLink;